import { render, staticRenderFns } from "./Buscador.vue?vue&type=template&id=1c40f0ec&"
import script from "./Buscador.vue?vue&type=script&lang=js&"
export * from "./Buscador.vue?vue&type=script&lang=js&"
import style0 from "./Buscador.vue?vue&type=style&index=0&id=1c40f0ec&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports